export default "__VITE_ASSET__D1$07r4s__"